// src/redux/cardsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, getNaniesByCategory } from '../../utils/Constants';

// Async thunk for fetching data
export const fetchnlistAsync = createAsyncThunk(
  "Nlist/fetchNlist",
  async (payload) => {
    const token = localStorage.getItem("Token");
    const headers = {
      Authorization: token,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    };
    try {
      const response = await axios.get(
        `${BASE_URL}${getNaniesByCategory}?categoryId=${payload?.categoryId}&address=${payload?.address}&latitude=${payload?.latitude}&longitude=${payload?.longitude}&date=${payload?.date}&time=${payload?.time}&numberOfHours=${payload?.counter}&skills=${payload?.skills}&languages=${payload?.languages}&mostExperienceAge=${payload?.ageGroup}`,
        { headers }
      ); // Replace with your API endpoint
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

const NlistSlice = createSlice({
  name: "Nlist",
  initialState: {
    data: null,
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchnlistAsync.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(fetchnlistAsync.fulfilled, (state, action) => {
        state.loading = "idle";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchnlistAsync.rejected, (state, action) => {
        state.loading = "idle";
        state.error = action.error.message;
      });
  },
});

export default NlistSlice.reducer;
